import { AxiosResponse } from 'axios';
import { ActWizard } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

export const transformerMenu = (
  response: AxiosResponse<HttpResponse<ActWizard>>
): Array<ItemVM> => {
  const listResponse = response.data?.payload?.percorsoQuestionarioVOList || [];

  if (listResponse.length === 0) {
    // oggetto vuoto
    return [] as Array<ItemVM>;
  }

  return listResponse.map((item) => ({
    id: item.key?.codStepSuccessivo || '0',
    value: item.rispostaQuestionarioVO?.descrizioneBreve || '',
  }));
};
